module.exports = __webpack_public_path__ + "9c36fed70b1e93df7fddfc0c6b15c9fb.svg";